import { request } from '/@/axios/request'

/**
 * 套餐相关API接口
 */

// 获取套餐列表
export function getPlans(params, options) {
  return request('/customer/plan/getPlans', params, options, 'get')
}

// 获取用户当前套餐
export function getUserPlan(params, options) {
  return request('/customer/plan/getUserPlan', params, options, 'get')
}

// 获取用户已购买的套餐列表
export function getUserPurchasedPlans(params, options) {
  return request('/customer/plan/getUserPurchasedPlans', params, options, 'get')
}

// 选择套餐
export function choosePlan(params, options) {
  return request('/customer/plan/choose', params, options, 'post')
}
